<template>
  <div class="fileSearch">
    <header>
      <el-tooltip effect="dark" content="返回" placement="bottom">
        <button @click="backtrack" style="cursor:pointer" class="returnBtn">
          <i class="el-icon-back"></i>
        </button>
      </el-tooltip>
      <p>文件内容搜索</p>
    </header>
    <main>
      <div class="searchBox">
        <el-input v-model="search" placeholder="输入文件内容关键词" @change="onSearch">
          <i slot="suffix" class="el-input__icon icon-search"></i>
        </el-input>
        <p>共搜索到{{totalRows}}个结果</p>
      </div>
      <div class="searchWrapper" style="overflow:auto">
        <ul class="searchMain" v-infinite-scroll="getPage" infinite-scroll-disabled="disabled"
          :infinite-scroll-immediate="false" :infinite-scroll-distance='50'>
          <li v-for="(item,index) in tabData" :key="index">
            <h5 class="tit"><span>{{index+1 | filterNum}}.</span>{{item.name}}</h5>
            <!-- <p v-for="(val,i) in item.txt" :key="i">
              <span>{{i+1}}. </span>{{val}}
            </p> -->
            <p v-html="item.sourceText" @click="toEditor(item)"></p>
            <div class="botBox"><span>创建时间：{{item.createTime}}</span><span>所属项目：{{item.projectName}}</span></div>
          </li>
        </ul>
        <!-- <p class="hint" v-if="loading">加载中...</p> -->
        <p class="hint" v-if="noMore&&!(tabData.length<1)">没有更多了</p>
        <div class="notDate" v-if="tabData.length<1">
          <img src="../../assets/imgs/memory/no_data.png" alt @click="isPlay=true" />
          <p @dblclick="musicPlayer">空空如也</p>
          <audio id="musicPlayer" preload="auto" controls="controls" :src="audioUrl" style="display:none">
          </audio>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
export default {
  name: "fileSearch",
  beforeRouteEnter (to, from, next) {
    const nodeName = process.env.VUE_APP_NAME;
    if (nodeName === 'drill') {
      next();
    } else {
      next({ path: "/404" });
    }
  },
  data() {
    return {
      search: "",
      tabData: [],
      audioUrl: "http://ws.stream.qqmusic.qq.com/C400002hqnLP2Z5y55.m4a?guid=7427283448&vkey=15B40FC651E851C100D269640CF91A3412D7AB83917F90F3ECA7E16EB441B36B8979661C6CA025053B471612E6D66CF73D01CA979AF7C3DB&uin=0&fromtag=66",
      isPlay: false,
      loading: false,
      noMore: false,
      page: 0,
      totalRows: 0
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore
    }
  },
  created() {

  },
  filters: {
    filterNum: function (value) {
      if (value > 9) return value
      value = '0' + value
      return value
    }
  },
  methods: {
    onSearch() {
      this.tabData = [];
      this.totalRows = 0;
      this.page = 1;
      this.getPage();
    },
    // 文件详情
    async getFileInformation(id) {
      let params = {
        id: id,
      };
      const response = await this.catReq1Service("/api/v1/file/get", params);
      if (!response.success) {
        return;
      }
      let data = response.result;
      return data
    },
    async toEditor(row) {
      const params = await this.getFileInformation(row.id);
      let path = "/editor";
      const fileSuffix = params.fileUsableSuffix;
      if (fileSuffix === "xls" || fileSuffix === "xlsx") {
        path = "/editorXls";
      } else if (
        fileSuffix === "ppt" ||
        fileSuffix === "pptx" ||
        fileSuffix === "html" ||
        fileSuffix === "xlf" ||
        fileSuffix === "htm"
      ) {
        path = "/editorTab";
      }
      let data = {
        fileId: row.id,
        project: params.finish,
        sourceLang: row.sourceLang,
        targetLang: row.targetLang,
        taskName: row.name,
        userId: "",
        wordNum: params.sourceWordNum,
        transStatus: 2,
        isSplit: params.isSplit,
        langDesc: params.langDesc,
        taskType: 1,
        fileSuffix,
        progress: params.progress,
        isExtract: params.isExtract,
        transModel:params.transModel
      };
      let routeData = this.$router.resolve({
        path,
        query: {
          key: this.$Base64.encode(
            JSON.stringify(data)
          ),
        },
      });
      window.open(routeData.href, "_blank");
    },
    async getPage() {
      if (!this.page) {
        return
      }
      this.search = this.search.replace(
        /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
        ""
      );
      if (this.search.length < 2) {
        this.$message.closeAll();
        this.$message({
          message: "查询内容请输入两字及以上",
          type: "warning",
        });
        return
      }
      this.loading = true;
      const params = {
        page: this.page,
        rows: 10,
        filter: {
          context: this.search,
          companyCode: localStorage.myCompanyCode,
          platformType: this.$platformType
        },
        // sort: sort || { create_time: "desc" }
      };
      const res = await this.catReq1Service("/api/v1/file/file_search_document", params);
      if (res.success) {
        this.loading = false;
        if (res.list.length) {
          this.tabData = [...this.tabData, ...res.list];
          this.page++
        } else {
          this.noMore = true;
        }
        this.totalRows = res.totalRows;
      }
    },
    // 返回上一页
    backtrack() {
      this.$router.go(-1);
    },
    // 播放
    musicPlayer() {
      this.isPlay ? musicPlayer.play() : '';
    }
  }
};
</script>
<style lang="less" scoped>
.fileSearch {
  height: 100%;
  a:visited {
    color: rgba(102, 102, 102, 1);
    text-decoration: none;
  }
  header {
    width: 100%;
    height: 58px;
    line-height: 58px;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    .returnBtn {
      width: 48px;
      height: 30px;
      line-height: 30px;
      background: #02A4FD;
      color: #fff;
      position: absolute;
      left: 30px;
      top: 50%;
      margin-top: -15px;
      font-size: 18px;
    }
    p {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  main {
    height: 100%;
    position: relative;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 38px;
    padding: 20px;
    padding-top: 10px;
    box-sizing: border-box;
    text-align: left;
    .searchBox {
      color: #333333;
      height: 36px;
      margin-bottom: 20px;
      .icon-search {
        background: url("../../assets/imgs/project/sswj.png") center no-repeat;
        position: relative;
        height: 19px;
        width: 19px;
        display: block;
        top: 8px;
      }
      .el-input {
        width: 250px;
        /deep/.el-input__inner {
          border: 0px;
          border-bottom: 1px solid #9e9a9a;
          border-radius: 0px;
        }
      }
      p {
        display: inline-block;
        color: rgba(43, 139, 229, 1);
        font-size: 14px;
        line-height: 36px;
        margin-left: 45px;
      }
    }
  }
  .searchWrapper {
    height: calc(100% - 50px);
    .hint {
      text-align: center;
      margin: 5px 0px;
      color: #999999;
    }
  }
  .searchMain {
    li {
      border-bottom: 1px dashed rgba(216, 212, 208, 1);
      margin-bottom: 10px;
      padding: 10px;
      height: auto;
      p {
        margin-bottom: 10px;
        margin-left: 10px;
        cursor: pointer;
        line-height: 24px;
      }
      .botBox {
        display: flex;
        flex-direction: row-reverse;
        margin-bottom: 10px;
        color: rgba(153, 153, 153, 1);
        font-size: 16px;
        span:nth-child(1) {
          margin-left: 80px;
        }
      }
    }
    .tit {
      span {
        margin-right: 5px;
      }
      margin-bottom: 10px;
    }
  }
  .notDate {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    p {
      margin-top: 30px;
      color: #909399;
    }
  }
}
</style>

